import type {EvaluationProfileVersion,QualityGatePolicyVersion} from './types';
/** New runs use executable installed definitions; old runs retain their frozen IDs. */
export function runnableProfiles(items:EvaluationProfileVersion[]){
 return currentProfileVersions(items).filter(item=>item.status==='active'&&item.current_deployment&&item.runnable&&item.profile_key!=='tts.compat');
}

export function currentQualityPolicies(items:QualityGatePolicyVersion[]){
 const groups=new Map<string,QualityGatePolicyVersion>();
 for(const item of items.filter(x=>x.status==='active'&&x.current_deployment)){
  const old=groups.get(item.policy_key);
  if(!old||item.system_default||(!old.system_default&&item.created_at>old.created_at))groups.set(item.policy_key,item);
 }
 return [...groups.values()];
}

export const LANGUAGE_NAMES:Record<string,string>={zh:'中文',en:'英语',ja:'日语',ko:'韩语'};
export function languageCode(value:string){const v=value.trim().toLowerCase().replaceAll('_','-');return ({english:'en',chinese:'zh',japanese:'ja',korean:'ko','中文':'zh','日语':'ja','韩语':'ko'} as Record<string,string>)[v]??v.split('-')[0];}
export function profilesForLanguages(items:EvaluationProfileVersion[],languages:string[]){
 const required=[...new Set(languages.map(languageCode))];
 return runnableProfiles(items).filter(p=>p.quality_gate_available!==false&&required.every(l=>(p.languages??['en','zh']).includes(l)));
}

export function currentProfileVersions(items:EvaluationProfileVersion[]){
 const groups=new Map<string,EvaluationProfileVersion>();
 for(const p of items.filter(p=>p.current_deployment&&p.status!=='deprecated')){
  const key=`${p.profile_key??p.id}:${p.status}`;const old=groups.get(key);
  if(!old||(p.created_at??'')>(old.created_at??'')||((p.created_at??'')===(old.created_at??'')&&(p.version??'').localeCompare(old.version??'',undefined,{numeric:true})>0))groups.set(key,p);
 }
 return [...groups.values()];
}

export function availableOptionalKeys(profile:EvaluationProfileVersion|undefined,keys?:string[]){
 const available=profile?.metrics.filter(m=>!m.required&&m.available).map(m=>m.metric_key)??[];
 return keys===undefined?available:available.filter(k=>keys.includes(k));
}

/** Resolve a single immutable selection for preview and submission; never substitute its gate. */
export function resolveEvaluationSelection(profiles:EvaluationProfileVersion[],gates:QualityGatePolicyVersion[],profileId:string|undefined,languages:string[],optionalKeys?:string[]){
 const profile=profilesForLanguages(profiles,languages).find(p=>p.id===profileId);
 if(!profile)throw new Error('当前语种没有匹配的可用方案，请重新选择评测方案');
 const gate=gates.find(g=>g.id===profile.quality_gate_policy_version_id);
 if(!gate||gate.status!=='active'||profile.quality_gate_available===false)throw new Error('方案绑定的质量要求不可用，请刷新后重新确认');
 const keys=availableOptionalKeys(profile,optionalKeys);
 if(optionalKeys&&(new Set(optionalKeys).size!==optionalKeys.length||keys.length!==optionalKeys.length))throw new Error('可选指标已变化，请重新核对本次选择');
 const metrics=profile.metrics.filter(m=>m.required||keys.includes(m.metric_key));
 if(metrics.some(m=>!m.available))throw new Error('方案必选指标当前不可用，请选择其他方案');
 const asr=metrics.some(m=>['asr.content_accuracy','asr.pause_screening','asr.speech_rate'].includes(m.evaluator_key??''));
 const mos=metrics.some(m=>m.evaluator_key==='sigmos.p804');
 return {profile,gate,optionalKeys:keys,metrics,asr,mos};
}
